import { api } from "./api";

export interface NewsItem {
  title: string;
  icon: string;
  sentence: string;
  roles: string[];
  help_screen: string | null;
}

export interface NewsRelease {
  date: string;
  items: NewsItem[];
}

export interface NewsResponse {
  releases: NewsRelease[];
  unseen: NewsRelease | null;
}

export const news = {
  load: async (signal: AbortSignal) =>
    (await api.get<NewsResponse>("/support/news", { signal })).data,
  seen: async (date: string) =>
    (await api.post<{ last_seen_news: string }>("/support/news/seen", { date }))
      .data,
};

export function newsDate(date: string) {
  return new Intl.DateTimeFormat("hr-HR", {
    dateStyle: "medium",
    timeZone: "UTC",
  }).format(new Date(`${date}T00:00:00Z`));
}
